"use strict";

import {
    AsYouType,
    isValidPhoneNumber,
    parsePhoneNumberWithError,
    getExampleNumber,
    ParseError
} from 'libphonenumber-js/min'

import examples from 'libphonenumber-js/mobile/examples'

document.addEventListener('DOMContentLoaded', function () {
    // Define the mapping of locale codes to telephone prefixes
    const prefixMap = {
        GB: '+44',
        FR: '+33',
        DE: '+49',
        IE: '+353',
        IT: '+39',
        ES: '+34',
        AT: '+43',
        BE: '+32',
        NL: '+31',
        JP: '+81'
    };

    // Add this after the prefixMap definition
    const phoneFormatRules = {
        JP: {
            format: (number) => {
                // Japanese format: +81 XX XXXX XXXX
                const digits = number.replace(/\D/g, '');
                // Don't add spaces until we have enough digits
                if (digits.length <= 2) return digits;
                if (digits.length <= 6) return `${digits.slice(0, 2)} ${digits.slice(2)}`;
                // Ensure we can enter all 10 digits
                return `${digits.slice(0, 2)} ${digits.slice(2, 6)} ${digits.slice(6)}`;
            },
            maxLength: 17 // +81 (3) + space (1) + XX (2) + space (1) + XXXX (4) + space (1) + XXXX (4) = 17
        },
        GB: {
            format: (number) => {
                // UK format: +44 XXXX XXXXXX
                const digits = number.replace(/\D/g, '');
                if (digits.length <= 4) return digits;
                return `${digits.slice(0, 4)} ${digits.slice(4, 10)}`;
            },
            maxLength: 16 // +44 (3) + space (1) + XXXX (4) + space (1) + XXXXXX (6) = 16
        },
        // Add more country formats as needed
    };

    // GET USERLOCALE
	var userLocale = document.documentElement.lang.substring(3, 5);
	if (userLocale.includes('uk')) {
	  userLocale.replace("uk", 'gb')
	}
	userLocale = userLocale.toUpperCase();

    // console.log(userLocale);
    // console.log(prefixMap[userLocale]);

    // Update the telephone prefix if the locale is in the map
    if (userLocale && prefixMap[userLocale]) {
        
        try {
            const localeData = prefixMap[userLocale];
            const flagId = document.getElementById('flag-' + userLocale);
            const selectedFlag = document.getElementById('selected-flag');
            const selectedPrefix = document.getElementById('selected-prefix');
            const telPrefix = document.getElementById('tel-prefix');
            const tel = document.getElementById('tel');
            const telHelper = document.getElementById('tel-helper');

            const regionCode = flagId.nextElementSibling.dataset.regioncode;
            const phoneNumberExample = parsePhoneNumberWithError(getExampleNumber(regionCode, examples).number).formatInternational();

            selectedFlag.innerHTML = flagId.innerHTML;
            selectedPrefix.textContent = localeData;
            telPrefix.value = localeData;
            tel.dataset.telprefix = flagId.nextElementSibling.innerHTML;
            tel.dataset.regioncode = regionCode;
            tel.setAttribute('maxlength', flagId.nextElementSibling.dataset.maxlength);
            tel.pattern = flagId.nextElementSibling.dataset.telpattern;

            telHelper.innerHTML = `${phoneNumberExample}`;

            tel.classList.remove('valid-phone-number');
            tel.value = `${localeData}`;
        } catch (error) {
            if (error instanceof ParseError) {
                // Not a phone number, non-existent country, etc.
                console.log(error.message)
            } else {
                throw error
            }
        }
    }

    // ------------------------------------
    // SWITCH TELEPHONE PREFIX EVENTS
    // ------------------------------------

    const toggleTelPrefixes = document.querySelector('.tel-prefix__toggle');
    const telPrefixes = document.querySelector('.tel-prefix__list');

    if (toggleTelPrefixes) {
        toggleTelPrefixes.addEventListener('click', function () {
            telPrefixes.classList.toggle('is-open');
        });
    }

    const phonePrefixes = document.querySelectorAll('.tel-prefix__list li button');

    phonePrefixes.forEach((prefix) => {
        prefix.addEventListener('click', (e) => {
            e.preventDefault();

            const selectedFlag = document.getElementById('selected-flag');
            const selectedPrefix = document.getElementById('selected-prefix');

            const tel = document.getElementById('tel');
            const telPrefix = document.getElementById('tel-prefix');
            const telHelper = document.getElementById('tel-helper');

            const telPrefixFlag = prefix.querySelector('.tel-prefix__flag');
            const telPrefixLabel = prefix.querySelector('.tel-prefix__label');

            const warningInvalidPattern = document.getElementById('phone-error');

            const regionCode = telPrefixLabel.dataset.regioncode;

            const phoneNumberExample = parsePhoneNumberWithError(getExampleNumber(regionCode, examples).number).formatInternational();

            selectedFlag.innerHTML = telPrefixFlag.innerHTML;
            selectedPrefix.innerHTML = telPrefixLabel.innerHTML;
            telPrefix.value = telPrefixLabel.innerHTML;

            // Remove the current value when the prefix is changed
            tel.value = `${telPrefixLabel.innerHTML}`;

            tel.dataset.telprefix = telPrefixLabel.innerHTML;
            tel.setAttribute('maxlength', telPrefixLabel.dataset.maxlength);
            tel.dataset.regioncode = regionCode;
            tel.pattern = telPrefixLabel.dataset.telpattern;

            telPrefixes.classList.toggle('is-open');
            telHelper.innerHTML = `${phoneNumberExample}`;

            tel.classList.remove('valid-phone-number');

            warningInvalidPattern.style.display = 'none';

            tel.focus();
        });
    });

    // ------------------------------------
    // TELEPHONE FIELD VALIDATION
    // ------------------------------------

    const telInputField = document.getElementById('tel');
    const errorElement = document.getElementById('phone-error');

    function toggleError(show) {
        errorElement.style.display = show ? 'block' : 'none';
        window.phoneNumberError = show ? true : false;
    }

    function isValidPhoneNumberForCountry(phoneNumberString, country) {
        try {
            const phoneNumber = parsePhoneNumberWithError(phoneNumberString, {
                defaultCountry: country,
                extract: false
            });

            return phoneNumber &&
                phoneNumber.country === country &&
                isValidPhoneNumber(phoneNumber.number, country) &&
                phoneNumber.isPossible();
        } catch (error) {
            if (error instanceof ParseError) {
                console.log('Parse error:', error.message);
            } else {
                console.error('Unexpected error:', error);
            }
            return false;
        }
    }

    function formatToInternational(number, regionCode) {
        try {
            return parsePhoneNumberWithError(number, regionCode).formatInternational();
        } catch (error) {
            console.error('Error formatting number:', error);
            return number;
        }
    }

    function validateAndFormatPhoneNumber(inputField, regionCode) {
        const trimmedValue = inputField.value.trim();
        const pattern = inputField.getAttribute('pattern');
        const regex = new RegExp(pattern);
        
        const noSpaceValue = trimmedValue.replace(/(?!^\+)\D/g, '');
    
        if (trimmedValue === '') {
            return toggleError(true);
        }
    
        const asYouType = new AsYouType(regionCode);
        const phoneNumber = asYouType.input(trimmedValue);
        const parsedNumber = asYouType.getNumber();
    
        if (!parsedNumber || !isValidPhoneNumberForCountry(parsedNumber.number, regionCode)) {
            return toggleError(true);
        }
    
        if (!asYouType.isInternational()) {
            inputField.value = formatToInternational(parsedNumber.number, regionCode);
        }
    
        // Re-check the formatted value
        const formattedNoSpaceValue = inputField.value.replace(/(?!^\+)\D/g, '');
        const isValidFormat = regex.test(formattedNoSpaceValue);
    
        // Check if the formatted number is international and matches the pattern
        const isValidInternational = asYouType.isInternational() && isValidFormat;
    
        if (isValidInternational) {
            return toggleError(false);
        }
    }
    

    function handleInput(event) {
        const inputField = event.target;
        const regionCode = inputField.dataset.regioncode;
        const prefix = inputField.dataset.telprefix;

        // Get the value without the prefix
        let value = inputField.value;
        if (value.startsWith(prefix)) {
            value = value.substring(prefix.length);
        }

        // Remove any existing formatting
        value = value.replace(/\s/g, '');

        // Apply country-specific formatting if available
        if (phoneFormatRules[regionCode]) {
            const rule = phoneFormatRules[regionCode];
            // Get the digits only (no spaces) for length checking
            const digitsOnly = value.replace(/\D/g, '');
            // Only truncate if we have more digits than allowed
            const truncatedValue = digitsOnly.length > 10 ? // Allow exactly 10 digits
                digitsOnly.slice(0, 10) : 
                value;
            const formattedNumber = rule.format(truncatedValue);
            
            // Only update if we have a valid number or are still typing
            if (formattedNumber || truncatedValue) {
                // Add space after prefix
                const fullNumber = prefix + ' ' + formattedNumber;
                // Set maxlength attribute to match our rule
                inputField.setAttribute('maxlength', rule.maxLength);
                inputField.value = fullNumber;
            }
        } else {
            // Fallback to AsYouType for countries without specific rules
            const asYouType = new AsYouType(regionCode);
            const formattedNumber = asYouType.input(value);
            
            if (formattedNumber || value) {
                // Add space after prefix
                inputField.value = prefix + ' ' + formattedNumber;
            }
        }

        const trimmedValue = inputField.value.trim();
        const asYouType = new AsYouType(regionCode);
        const parsedNumber = asYouType.getNumber();

        if (trimmedValue !== '' &&
            parsedNumber?.number &&
            isValidPhoneNumberForCountry(trimmedValue, regionCode)) {
                toggleError(false);
        }
    }

    function handleBlur(event) {
        const inputField = event.target;
        const regionCode = inputField.dataset.regioncode;

        try {
            validateAndFormatPhoneNumber(inputField, regionCode);
        } catch (error) {
            console.error('Unexpected error:', error);
            toggleError(true);
        }
    }

    if (telInputField) {
        telInputField.addEventListener('input', handleInput);
        telInputField.addEventListener('blur', handleBlur);
    }

});
